import React, { useEffect, useState } from "react";
import Navbar from "../../Components/Navbar/Navbar";
import Sidebar from "../../Components/Sidebar/Sidebar";
import ConfirmationModal from "../Modals/ConfirmationModal";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Dropdown from "../Dropdown/Dropdown";
// import { useNavigate } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import moment from "moment";
import "./Transaction.css";
import BookingItems from "./BookingItems";
import CleaningItem from "./CleaningItem";
import { convertTo12HourFormat } from "../../helper/helper";
import { servicePost } from "../../helper/api";
import OrderCancelModal from "../Modals/OrderCancelModal";
import IndustryCharge from "./IndustryCharge";
import ImageGallery from "./ImageGallery";

const TransactionDetail = () => {
  const [TxData, setTxData] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState();
  const [isCopied, setIsCopied] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [afterPopupOpen, setAfterPopupOpen] = useState(false);
  const [imageIndex, setImageIndex] = useState();
  const [afterImageIndex, setAfterImageIndex] = useState();
  const [activeImages, setActiveImages] = useState([]); // State for the currently active images

  const location = useLocation();
  const bookingId = location?.state?.bookingId;
  const navigate = useNavigate();

  // get AuthToken from localStorage
  const authToken = localStorage.getItem("token");
  const notification = "";

  console.log("TxData", TxData);

  let cartdata = TxData?.cartItems;
  const [chatMessages, setChatMessages] = useState([]);

  const handleImageClick = (index, type) => {
    if (type === "before") {
      setActiveImages(TxData.beforeImages);
    } else if (type === "after") {
      setActiveImages(TxData.afterImages);
    }
    setImageIndex(index); // Set the starting index of the clicked image
    setPopupOpen(true); // Open the modal
  };

  const handleAfterImageClick = (index, type) => {
    if (type === "before") {
      setActiveImages(TxData.beforeImages);
    } else if (type === "after") {
      setActiveImages(TxData.afterImages);
    }
    setAfterImageIndex(index);
    setAfterPopupOpen(true); // Open the modal
  };

  const getSingleBookingData = async () => {
    try {
      const singleBookingRes = await servicePost(
        "adminbooking/getBookingData",
        {
          bookingId: bookingId,
        },
        notification,
        authToken
      );
      console.log("singleBookingRes", singleBookingRes.BookingDetail);

      // Add status and statusImage fields
      const bookingsWithStatus = singleBookingRes.BookingDetail.map(
        (booking) => {
          let status = "";
          let statusImage = "";

          if (booking.cancelStatus === true) {
            status = "Cancelled";
            statusImage = "./images/icons/status-cancel.svg";
          } else if (
            booking.cleaningServiceStatus === "Completed" ||
            booking.bookingStatus === "Completed" ||
            booking.workCompleteStatus === true
          ) {
            status = "Completed";
            statusImage = "./images/icons/status-complete.svg";
          } else if (booking.bookingStatus === "Booking Confirmed") {
            status = "Accepted";
            statusImage = "./images/icons/status-accepted.svg";
          } else {
            status = "Processing";
            statusImage = "./images/icons/status-processing.svg";
          }

          // Return the booking with added status and statusImage
          return {
            ...booking,
            status,
            statusImage,
          };
        }
      );
      // Set the updated booking data
      setTxData(bookingsWithStatus[0]);
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    getSingleBookingData();
  }, [bookingId]);

  // Get Messages
  const getMessageData = async () => {
    try {
      const getMessageRes = await servicePost(
        "adminbooking/getMessageData",
        {
          bookingId: bookingId,
        },
        notification,
        authToken
      );

      console.log("getMessageRes", getMessageRes.BookingDetail);

      setChatMessages(getMessageRes?.BookingDetail);
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    getMessageData();
  }, [bookingId]);

  const handleCopy = () => {
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  };

  // Cancel Order By Admin
  const cancelOrderHandler = () => {
    setShowCancelModal(true);
  };

  const goToBack = () => {
    navigate("/transation");
  };

  const goToInvoiceDetail = () => {
    navigate("/invoice-detail", { state: { invoiceId: TxData?.invoiceId } });
  };

  // Go To User Account
  const goToAccDetail = () => {
    navigate("/account-detail", {
      state: { AccountId: TxData.accountId },
    });
  };

  // Go To Contractor Account
  const goToContractorAccDetail = () => {
    navigate("/contractoraccount-detail", {
      state: { AccountId: TxData.contractorid },
    });
  };

  return (
    <>
      <OrderCancelModal
        show={showCancelModal}
        onHide={() => setShowCancelModal(false)}
        showCloseIcon={true}
        data={TxData}
        // onOrderCancel={onOrderCancel}
      />
      <ConfirmationModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        type="Are you sure to change the status of this transaction"
      />
      <Navbar />
      <Sidebar />
      <div className="trasfer-histroy-wrapper transfer-admin-history-wrap">
        <div className="container">
          <div className="invoice-detail-main-wrap">
            <div className="invoice-payment-detail-left">
              <div className="cleaner-payment-detail-left">
                <div className="cleaner-payment-tx-wrap">
                  <img
                    onClick={goToBack}
                    src="./images/icons/back-arrow.png"
                    alt="icon"
                  />
                  <h3>
                    Transaction ID: <span> #{TxData?.bookingId}</span>
                  </h3>
                </div>
                <p>
                  Invoice:{" "}
                  {TxData?.invoiceId ? (
                    <span
                      className="active-tx-id"
                      onClick={() => goToInvoiceDetail()}
                    >
                      #{TxData?.invoiceId}
                    </span>
                  ) : (
                    <span> --------- </span>
                  )}
                </p>
              </div>

              <div className="invoice-booking-detail-wrap">
                <div className="invoice-booking-client">
                  <h3> Booking Details</h3>

                  <div className="booking-client-detail-wrap">
                    <div className="booking-client-detail">
                      <p>
                        Client:{" "}
                        {TxData?.clientName ? (
                          <span
                            className="active-tx-id"
                            onClick={() => goToAccDetail()}
                          >
                            {TxData?.clientName}
                          </span>
                        ) : (
                          <span>----</span>
                        )}
                      </p>
                      {/* <div className="send-mail-btn">
                        <p> Send Mail</p>
                        <img src="./images/icons/sent-mail.svg" alt="icon" />
                      </div> */}
                    </div>

                    <div className="booking-client-detail">
                      <div className="booking-client-icon-wrap">
                        <p>
                          Cleaner:{" "}
                          {TxData?.contractorName ? (
                            <span
                              className="active-tx-id"
                              onClick={() => goToContractorAccDetail()}
                            >
                              {TxData?.contractorName}
                            </span>
                          ) : (
                            <span>----</span>
                          )}
                        </p>
                        {/* <img src="./images/icons/edit-icon.png" alt="icon" /> */}
                      </div>

                      {/* <div className="send-mail-btn">
                        <p> Send Mail</p>
                        <img src="./images/icons/sent-mail.svg" alt="icon" />
                      </div> */}
                    </div>
                  </div>

                  <div className="invoice-booking-industry-wrap">
                    <h4>
                      {" "}
                      {TxData?.industry}
                      {TxData?.floors && ","} {TxData?.floors}{" "}
                      {TxData?.bedrooms && ","} {TxData?.bedrooms}{" "}
                    </h4>
                  </div>
                </div>
              </div>
            </div>

            <div className="cleaner-payment-detail-right">
              <div className="invoice-status-wrapper tx-status-wrapper-text">
                <h3> Status </h3>
              </div>
              <div className="transaction-status-btn-wrapper">
                <div className="invoce-status-btn-wrap">
                  <p> {TxData?.status} </p>
                </div>

                {TxData?.status !== "Cancelled" &&
                  TxData?.status !== "Completed" && (
                    <button onClick={cancelOrderHandler}> Cancel </button>
                  )}
              </div>
            </div>
          </div>

          <div className="invoice-booking-detail-bottom-wrapper">
            <div className="invoice-booking-detail-bottom-left">
              <div className="invoice-address-reapet">
                <div className="invoice-address-left">
                  <p> Address</p>
                </div>
                <div className="invoice-address-right">
                  <p> {TxData?.address} </p>
                </div>
              </div>

              <div className="invoice-address-reapet">
                <div className="invoice-address-left">
                  <p> Address line 2:</p>
                </div>
                <div className="invoice-address-right">
                  <p> {TxData?.addressLine2} </p>
                </div>
              </div>

              <div className="invoice-address-reapet">
                <div className="invoice-address-left">
                  <p> Postal code: </p>
                </div>
                <div className="invoice-address-right">
                  <p> {TxData?.postalCode} </p>
                </div>
              </div>

              <div className="invoice-address-reapet">
                <div className="invoice-address-left">
                  <p> Schedule: </p>
                </div>
                <div className="invoice-address-right">
                  <img src="./images/icons/date.svg" alt="icon" />
                  <p className="right-border-line">
                    {moment(TxData?.scheduleDate).format("DD MMM, YYYY")}
                  </p>
                  <img src="./images/icons/time.svg" alt="icon" />
                  <p>{TxData?.scheduleTime}</p>
                </div>
              </div>

              <div className="contact-person-detail">
                <h4> Contact Person</h4>
              </div>
              <div className="invoice-address-reapet">
                <div className="invoice-address-left">
                  <p> Name </p>
                </div>
                <div className="invoice-address-right">
                  <p>
                    {" "}
                    {TxData?.contactPersonName
                      ? TxData?.contactPersonName
                      : "---"}{" "}
                  </p>
                </div>
              </div>

              <div className="invoice-address-reapet">
                <div className="invoice-address-left">
                  <p> Number </p>
                </div>
                <div className="invoice-address-right">
                  <p>
                    {TxData?.contactPersonNumber
                      ? TxData?.contactPersonNumber
                      : "---"}
                  </p>
                </div>
              </div>
            </div>

            <div className="invoice-booking-detail-bottom-right">
              <div className="invoice-address-reapet">
                <div className="invoice-address-left">
                  <p> Payment Method:</p>
                </div>
                <div className="invoice-address-right">
                  <img src="./images/icons/card.svg" alt="icon" />
                  <p>{TxData?.paymentMethod} </p>
                </div>
              </div>

              <div className="invoice-address-reapet">
                <div className="invoice-address-left">
                  <p> Payment #ID </p>
                </div>
                <div className="invoice-address-right">
                  <p> -</p>
                </div>
              </div>

              <div className="invoice-address-reapet">
                <div className="invoice-address-left">
                  <h4> Total </h4>
                </div>
                <div className="invoice-address-right">
                  <h4> ${TxData?.total}</h4>
                </div>
              </div>

              <div className="invoice-address-reapet">
                <div className="invoice-address-left">
                  <p> Sub total </p>
                </div>
                <div className="invoice-address-right">
                  <p> ${TxData?.subTotal}</p>
                </div>
              </div>

              <div className="invoice-address-reapet">
                <div className="invoice-address-left">
                  <p> YFOS Service </p>
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    overlay={
                      <Tooltip id={`tooltip-top`}>
                        YFOS service fees include company charges to ensure
                        quality service and operational excellence.
                      </Tooltip>
                    }
                  >
                    <img src="./images/icons/info.svg" alt="icon" />
                  </OverlayTrigger>
                </div>
                <div className="invoice-address-right">
                  <p className="discount-text">
                    -${Number(TxData?.yfosServiceCharge)?.toFixed(2)}
                  </p>
                </div>
              </div>

              <div className="invoice-address-reapet">
                <div className="invoice-address-left">
                  <p> Taxes and Fee </p>
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    overlay={
                      <Tooltip id={`tooltip-top`}>
                        Additional fees may apply for shipping, handling, and
                        taxes.
                      </Tooltip>
                    }
                  >
                    <img src="./images/icons/info.svg" alt="icon" />
                  </OverlayTrigger>
                </div>
                <div className="invoice-address-right">
                  <p>${Number(TxData?.fees).toFixed(2)} </p>
                </div>
              </div>

              <div className="invoice-address-reapet">
                <div className="invoice-address-left">
                  <p> Discount </p>
                </div>
                <div className="invoice-address-right">
                  <p className="discount-text">${TxData?.discount} </p>
                </div>
              </div>

              <div className="invoice-payout-wrapper">
                <div className="invoice-payout-wrap">
                  <h3> Cleaner Commission </h3>
                  <p>
                    $
                    {(TxData?.subTotal - TxData?.yfosServiceCharge)?.toFixed(2)}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="transation-cart-detail-wrap">
            <div className="transation-cart-item-wrap">
              <h4> Your Cart</h4>

              <div className="booking-cart-items-wrap tracking-cart-item-wrap">
                {TxData?.industry !== "Specialty Cleaning" && (
                  <div className="cart-sqfeet-wrap">
                    <p> Square Feet of your Home</p>
                    <p> {TxData?.squireFeet} SQ</p>
                  </div>
                )}

                <h5> Items </h5>
                <div className="tranking-booking-cart-item">
                  {TxData?.industry == "Post Construction" ? (
                    <IndustryCharge
                      image="./images/icons/yfos-logo.png"
                      category={TxData?.bedrooms}
                      label="Surcharge"
                      percentage={TxData?.industrySurcharge}
                      price={TxData?.industrySurcharge}
                      type="industry charges"
                      pageType="TrankingOrder"
                    />
                  ) : (
                    <IndustryCharge
                      image="./images/icons/yfos-logo.png"
                      category={TxData?.industry}
                      label="Surcharge"
                      percentage={TxData?.industrySurcharge}
                      price={TxData?.industrySurcharge}
                      type="industry charges"
                      pageType="TrankingOrder"
                    />
                  )}

                  <IndustryCharge
                    image="./images/icons/yfos-logo.png"
                    category={TxData?.floors}
                    label="Surcharge"
                    percentage={TxData?.floorSurcharge}
                    price={TxData?.floorSurcharge}
                    type="floors charges"
                    pageType="TrankingOrder"
                  />
                  <CleaningItem
                    image="./images/icons/vacuum-icon.png"
                    category="Flooring:"
                    label="Vacuum Cleaning"
                    percentage={TxData?.vacummCleaning}
                    price={TxData?.vacummCleaningPrice}
                  />
                  <CleaningItem
                    image="./images/icons/mopping-icon.png"
                    category="Flooring:"
                    label="Mopping or sweeping"
                    percentage={TxData?.moppingCleaning}
                    price={TxData?.moppingCleaningPrice}
                  />
                  <CleaningItem
                    image="./images/dusting-slider.png"
                    category="Dusting:"
                    label="Dusting"
                    percentage={TxData?.dusting}
                    price={TxData?.dustingPrice}
                  />
                </div>

                <div className="tranking-booking-cart-item">
                  {cartdata?.map((item, index) => (
                    <BookingItems key={index} item={item} />
                  ))}
                </div>
              </div>
            </div>

            <div className="transation-cart-status-wrapper">
              <div className="transation-cart-header">
                <h4> Status</h4>
                <img src="./images/icons/status-icon.svg" alt="icon" />
              </div>

              <div className="transation-cart-status-wrap">
                {TxData?.otp && (
                  <>
                    <div className="transation-card-otp-wrap">
                      <p> OTP: {TxData?.otp}</p>
                      <CopyToClipboard text={TxData?.otp} onCopy={handleCopy}>
                        <img src="./images/icons/copy.svg" alt="icon" />
                      </CopyToClipboard>
                      {isCopied && <span className="copied-text">Copied!</span>}
                    </div>
                  </>
                )}

                {/* <div className="order-track">
                  <div className="order-track-step">
                    <div className="order-track-status">
                      <img src="./images/icons/location.svg" alt="icon" />
                      <span className="order-track-status-line"></span>
                    </div>
                    <div className="order-track-text">
                      <p className="order-track-text-stat">YFOS Company</p>
                      <span className="order-track-text-sub">
                        {TxData?.companyAddress}
                      </span>
                    </div>
                  </div>

                  <div className="order-track-step">
                    <div className="order-track-status">
                      <img
                        className="dot-icon"
                        src="./images/icons/dot.svg"
                        alt="icon"
                      />

                      <span className="order-track-status-line"></span>
                    </div>
                    <div className="order-track-text">
                      <p className="order-track-processing">
                        {" "}
                        {TxData?.bookingStatus}
                      </p>
                      <span className="order-track-text-sub">
                        {convertTo12HourFormat(
                          TxData?.bookingTime ? TxData?.bookingTime : ""
                        )}{" "}
                        , {""}
                        {TxData?.bookingDate}
                      </span>
                    </div>
                  </div>
                </div> */}

                <div className="order-track-main-wrapper">
                  <div className="order-track">
                    <div className="order-track-step">
                      <div className="order-track-status">
                        <img src="./images/icons/location.svg" alt="icon" />
                        <span className="order-track-status-line"></span>
                      </div>
                      <div className="order-track-text">
                        <p className="order-track-text-stat">YFOS Company</p>
                        <span className="order-track-text-sub">
                          {TxData?.companyAddress}
                        </span>
                      </div>
                    </div>

                    <>
                      <div className="order-track-step">
                        <div className="order-track-status">
                          <span className="order-track-status-dot"></span>
                          <span className="order-track-status-line"></span>
                        </div>
                        {TxData?.bookingStatus && (
                          <div className="order-track-text">
                            <p className="order-track-label">
                              {TxData?.bookingStatus == "Completed"
                                ? "Booking Confirmed"
                                : TxData?.bookingStatus}
                            </p>
                            <span className="order-track-text-sub">
                              {convertTo12HourFormat(
                                TxData?.bookingTime ? TxData?.bookingTime : ""
                              )}{" "}
                              , {""}
                              {TxData?.bookingDate
                                ? moment(TxData?.bookingDate, [
                                    "DD/MM/YYYY",
                                    "MM/DD/YYYY",
                                  ]).isValid()
                                  ? moment(TxData?.bookingDate, [
                                      "DD/MM/YYYY",
                                      "MM/DD/YYYY",
                                    ]).format("DD MMM, YYYY")
                                  : "Invalid date"
                                : "--"}
                            </span>
                          </div>
                        )}
                      </div>

                      {TxData?.cleanerPartnerStatus && (
                        <div className="order-track-step">
                          <div className="order-track-status">
                            <span className="order-track-status-dot"></span>
                            <span className="order-track-status-line"></span>
                          </div>
                          <div className="order-track-text">
                            <p className="order-track-label">
                              {TxData?.cleanerPartnerStatus}
                            </p>
                            {/* <span className="order-track-text-sub">
                Stay Connected with Cleaner Partner
              </span> */}
                            {/* <h5> +1 (657)-747-7467 </h5> */}
                            <p className="order-text-schedul">
                              {convertTo12HourFormat(
                                TxData?.assignedTime ? TxData?.assignedTime : ""
                              )}{" "}
                              , {""}
                              {TxData?.assignedDate
                                ? moment(TxData?.assignedDate, [
                                    "DD/MM/YYYY",
                                    "MM/DD/YYYY",
                                  ]).isValid()
                                  ? moment(TxData?.assignedDate, [
                                      "DD/MM/YYYY",
                                      "MM/DD/YYYY",
                                    ]).format("DD MMM, YYYY")
                                  : "Invalid date"
                                : "--"}
                            </p>
                          </div>
                        </div>
                      )}

                      {TxData?.dispatchedStatus && (
                        <div className="order-track-step">
                          <div className="order-track-status">
                            <span className="order-track-status-dot"></span>
                            <span className="order-track-status-line"></span>
                          </div>
                          <div className="order-track-text">
                            <p className="order-track-label">
                              Cleaner Partner has been Dispatched.
                            </p>
                            <span className="order-track-text-sub">
                              {/* 12:00 AM , 21 Nov 2024 */}
                              {moment(TxData?.dispatchedDate).format(
                                "hh:mm A, DD MMM YYYY"
                              )}
                            </span>
                          </div>
                        </div>
                      )}

                      {TxData?.arrivedStatus && (
                        <div className="order-track-step">
                          <div className="order-track-status">
                            <span className="order-track-status-dot"></span>
                            <span className="order-track-status-line"></span>
                          </div>
                          <div className="order-track-text">
                            <p className="order-track-label">
                              Arrived at your Location
                            </p>

                            <p className="order-text-schedul">
                              {convertTo12HourFormat(
                                TxData?.arrivedTime ? TxData?.arrivedTime : ""
                              )}
                              , {""}
                              {TxData?.arrivedDate
                                ? moment(TxData?.arrivedDate, [
                                    "DD/MM/YYYY",
                                    "MM/DD/YYYY",
                                  ]).isValid()
                                  ? moment(TxData?.arrivedDate, [
                                      "DD/MM/YYYY",
                                      "MM/DD/YYYY",
                                    ]).format("DD MMM, YYYY")
                                  : "Invalid date"
                                : "--"}
                            </p>
                          </div>
                        </div>
                      )}

                      {TxData?.otpAccepted && (
                        <div className="order-track-step">
                          <div className="order-track-status">
                            <span className="order-track-status-dot"></span>
                            <span className="order-track-status-line"></span>
                          </div>
                          <div className="order-track-text">
                            <p className="order-track-label">
                              OTP Shared by the Customer
                            </p>
                            <span className="order-track-text-sub">
                              {moment(TxData?.otpAcceptedDate).format(
                                "hh:mm A, DD MMM YYYY"
                              )}
                            </span>
                          </div>
                        </div>
                      )}

                      {TxData?.workStartedStatus && (
                        <div className="order-track-step">
                          <div className="order-track-status">
                            <span className="order-track-status-dot"></span>
                            <span className="order-track-status-line"></span>
                          </div>
                          <div className="order-track-text">
                            <p className="order-track-label">
                              Cleaner Has Started the Work
                            </p>
                            <span className="order-track-text-sub">
                              {/* 12:04 AM , 21 Nov 2024 */}
                              {moment(TxData?.workStartedDate).format(
                                "hh:mm A, DD MMM YYYY"
                              )}
                            </span>
                          </div>
                        </div>
                      )}

                      {TxData.cancelStatus && (
                        <div className="order-track-step">
                          <div className="order-track-status">
                            <span className="order-track-status-dot"></span>
                            <span className="order-track-status-line"></span>
                          </div>
                          <div className="order-track-text">
                            <p className="order-track-label">
                              Booking Cancelled by the {TxData?.cancelBy}
                            </p>
                            <span className="order-track-text-sub">
                              {TxData?.cancelReason}
                            </span>
                          </div>
                        </div>
                      )}

                      {TxData.refundStatus && (
                        <div className="order-track-step">
                          <div className="order-track-status">
                            <span className="order-track-status-dot"></span>
                            <span className="order-track-status-line"></span>
                          </div>
                          <div className="order-track-text">
                            <p className="order-track-label">
                              Refundable Amount
                            </p>
                            <span className="order-track-text-sub">
                              ${Number(TxData?.refundValue).toFixed(2)}
                            </span>
                          </div>
                        </div>
                      )}

                      {TxData?.workCompleteStatus && (
                        <div className="order-track-step order-track-long-step">
                          <div className="order-track-status">
                            <img
                              className="order-step-complete-icon"
                              src="./images/confirm-tick.png"
                              alt="icon"
                            />
                            <span className="order-track-status-line"></span>
                          </div>
                          <div className="order-track-text">
                            <p className="order-track-label">
                              Cleaning Service Complete
                            </p>
                            <span className="order-track-text-sub">
                              {moment(TxData?.workCompleteDate).format(
                                "hh:mm A, DD MMM YYYY"
                              )}
                            </span>
                          </div>
                        </div>
                      )}
                    </>
                  </div>
                </div>
              </div>
            </div>
            <div className="transation-cart-chat-wrap">
              <div className="transation-cart-header">
                <h4> Chat</h4>
                <img src="./images/icons/chat-icon.svg" alt="icon" />
              </div>

              <div className="replay-chat-box-wrapper">
                {chatMessages?.length == 0 ? (
                  <div className="empty-conversation-wrap">
                    <img src="./images/empty-chat.png" alt="icon" />
                    <h3> No Conversation</h3>
                    <p> No Chat Available yet!</p>
                  </div>
                ) : (
                  <div className="replay-chat-box-wrap">
                    <section className="msger">
                      <main className="msger-chat">
                        <div className="chat-messages-wrap">
                          {chatMessages.map((msg, index) => (
                            <React.Fragment key={index}>
                              <div
                                className={`cleaner-partner ${
                                  msg.userId == TxData.accountId
                                    ? "right"
                                    : "left"
                                }`}
                              ></div>
                              <div
                                className={`msg ${
                                  msg.userId == TxData.accountId
                                    ? "right-msg"
                                    : "left-msg"
                                }`}
                              >
                                <div className="msg-bubble">
                                  <div className="msg-text">{msg.message}</div>
                                </div>
                              </div>
                              <div
                                className={`${
                                  msg.userId == TxData.accountId
                                    ? "right"
                                    : "left"
                                }-info-time`}
                              >
                                <p>{moment(msg.createdAt).fromNow()}</p>
                              </div>
                            </React.Fragment>
                          ))}
                        </div>
                      </main>
                    </section>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="transation-complete-image-wrapper">
            <div className="transation-complete-image-wrap">
              <h3> Images </h3>

              <div className="after-before-image-wrap">
                {TxData?.beforeImages?.length > 0 && (
                  <div className="after-images-wrap">
                    <img
                      onClick={() => handleImageClick(0, "before")}
                      src={TxData?.beforeImages[0]}
                      alt="after-img"
                    />
                    <ImageGallery
                      show={popupOpen}
                      onHide={() => setPopupOpen(false)}
                      imageIndex={imageIndex}
                      // images={TxData.beforeImages?.map((file) => file)}
                      images={activeImages}
                    />

                    <div className="after-image-count">
                      <p> {TxData?.beforeImages?.length} </p>
                    </div>

                    <div
                      className="after-button-wrap"
                      onClick={() => handleImageClick(0, "before")}
                    >
                      <p> Before </p>
                    </div>
                  </div>
                )}

                {TxData?.afterImages?.length > 0 && (
                  <div className="after-images-wrap">
                    <img
                      onClick={() => handleAfterImageClick(0, "after")}
                      src={TxData?.afterImages[0]}
                      alt="after-img"
                    />

                    <div className="after-image-count">
                      <p> {TxData?.afterImages?.length} </p>
                      <ImageGallery
                        show={afterPopupOpen}
                        onHide={() => setAfterPopupOpen(false)}
                        imageIndex={afterImageIndex}
                        // images={TxData.afterImages?.map(
                        //   (file) => file
                        // )}
                        images={activeImages}
                      />
                    </div>
                    <div
                      className="after-button-wrap"
                      onClick={() => handleAfterImageClick(0, "after")}
                    >
                      <p> After </p>
                    </div>
                  </div>
                )}

                {TxData?.reviewReating && (
                  <div className="order-status-customer-review">
                    <h3> Customer Review </h3>
                    <div className="order-status-customer-review-stars">
                      {[...Array(5)].map((star, index) => {
                        const currentRate = index + 1;
                        return (
                          <label key={index}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="23.064"
                              height="22.365"
                              viewBox="0 0 23.064 22.365"
                              aria-label={`Star ${TxData?.reviewReating}`}
                            >
                              <path
                                id="star"
                                d="M1.216,11.375l3.261,2.382L3.239,17.592A2.957,2.957,0,0,0,7.8,20.885l3.189-2.347,3.19,2.344a2.956,2.956,0,0,0,4.565-3.29l-1.239-3.836,3.261-2.382A2.956,2.956,0,0,0,19.03,6.033H15.024L13.808,2.244a2.956,2.956,0,0,0-5.63,0L6.963,6.033h-4A2.956,2.956,0,0,0,1.22,11.375Z"
                                transform="translate(0.537 0.31)"
                                fill={
                                  currentRate <= TxData?.reviewReating
                                    ? "#FFD60A"
                                    : "none"
                                }
                                stroke="#e2e2e2"
                                strokeWidth="1"
                              />
                            </svg>
                          </label>
                        );
                      })}
                    </div>
                    <p>{TxData?.reviewText}</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TransactionDetail;
